/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { isAgency } from '../../Utilities/IsAgency/IsAgency';
import { isOrganisation } from '../../Utilities/IsOrganisation/IsOrganisation';

/**
 * Return the reference ID of the current tenant based on the URL.
 * @export
 * @returns {string} Returns the reference ID of the tenant if applicable.
 */
export const getTenantFromUrl = (): string => {
  const urlParts = location.pathname.split('/');

  if (isOrganisation()) {
    return urlParts[urlParts.indexOf('organization') + 1];
  }

  if (isAgency()) {
    return urlParts[urlParts.indexOf('agency') + 1];
  }

  return '';
};
